'use client';
import { useTranslations } from 'next-intl';
import { CatButton } from 'components/blocks-components';
import { useRequestEquipmentService } from 'components/request-equipment-service/request-equipment-service-context';
import { RequestServiceCTAButtonProps } from '../../types';
import styles from './product-request-service-button.module.scss';

export const RequestServiceCTAButton = ({
  gaEventDetails
}: RequestServiceCTAButtonProps) => {
  const t = useTranslations();
  const { setIsRSModalOpen } = useRequestEquipmentService();
  return (
    <CatButton
      onClick={() => setIsRSModalOpen(true)}
      fullWidth
      size="sm"
      className={styles['product-request-information-cta']}
      data-track-event={gaEventDetails?.gaprimaryCTA}
      data-track-attr-nltext={gaEventDetails?.gaBtnEventName}
      data-track-attr-context={gaEventDetails?.gaEventContext}
    >
      {t('PDP_REQUEST_INFORMATION')}
    </CatButton>
  );
};
